/**
 * This file contains consistent SEO data structures for use across the site.
 * Centralizing this data ensures consistency and makes updates easier.
 */

export const SITE_NAME = 'Cosmik Drones';
export const SITE_URL = 'https://cosmikdrones.com';
export const OWNER_NAME = 'Josh Kolonia';
export const OWNER_EMAIL = 'Josh@Cosmikdrones.com';
export const PHONE_NUMBER = '+1-610-509-0867';

export const PRIMARY_LOCATION = {
  name: 'Lehigh Valley',
  region: 'PA',
  country: 'US',
  postalCode: '18018',
  geo: {
    latitude: '40.6084',
    longitude: '-75.4907'
  }
};

export const BUSINESS_HOURS = {
  monday: '9:00 AM - 6:00 PM',
  tuesday: '9:00 AM - 6:00 PM',
  wednesday: '9:00 AM - 6:00 PM',
  thursday: '9:00 AM - 6:00 PM',
  friday: '9:00 AM - 6:00 PM',
  saturday: '10:00 AM - 4:00 PM',
  sunday: 'Closed'
};

export const SOCIAL_PROFILES = {
  instagram: 'https://instagram.com/josh.kolonia',
  youtube: 'https://youtube.com/cosmikdrones',
  facebook: 'https://facebook.com/cosmikdrones'
};

export const GEO_FOCUS = [
  { name: 'Lehigh Valley', state: 'PA', primary: true },
  { name: 'Allentown', state: 'PA', primary: true },
  { name: 'Bethlehem', state: 'PA', primary: true },
  { name: 'Easton', state: 'PA', primary: true },
  { name: 'Nazareth', state: 'PA', primary: false },
  { name: 'Emmaus', state: 'PA', primary: false },
  { name: 'Philadelphia', state: 'PA', primary: false },
  { name: 'Eastern Pennsylvania', state: 'PA', primary: false },
  { name: 'East Coast', region: 'US-East', primary: false }
];

export const SERVICES = [
  {
    id: 'fpv-drone-filming',
    name: 'FPV Drone Filming',
    description: 'Immersive and dynamic FPV drone cinematography for captivating aerial footage with unique perspectives',
    keywords: ['fpv drone filming', 'aerial cinematography', 'drone videos']
  },
  {
    id: 'aerial-photography',
    name: 'Aerial Photography',
    description: 'High-resolution aerial photography services for breathtaking bird\'s-eye views',
    keywords: ['aerial photography', 'drone photography', 'aerial imaging']
  },
  {
    id: 'real-estate',
    name: 'Real Estate & Property',
    description: 'Specialized drone services for real estate marketing including property showcases and virtual tours',
    keywords: ['real estate drone', 'property drone photography', 'real estate aerial']
  },
  {
    id: 'events',
    name: 'Events & Sports Coverage',
    description: 'Dynamic event coverage with aerial perspectives for sports, concerts, weddings, and special occasions',
    keywords: ['event drone coverage', 'sports drone filming', 'aerial event photography']
  }
];

export const DEFAULT_META_DESCRIPTION = 
  'Cosmik Drones offers professional drone services in Lehigh Valley, PA including ' +
  'aerial photography, FPV drone filming, real estate videography, and event coverage ' +
  'throughout Pennsylvania and the East Coast. FAA-certified and fully insured.';

export const DEFAULT_META_KEYWORDS = 
  'drone services, aerial photography, FPV drone, Lehigh Valley, Pennsylvania, ' +
  'East Coast, real estate drone, event drone, cinematic drone, FAA certified';

/**
 * Helper functions for SEO data
 */
export const generateTitle = (pageTitle) => 
  pageTitle ? `${SITE_NAME} | ${pageTitle}` : SITE_NAME;

export const generateCanonicalUrl = (path) => 
  path ? `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}` : SITE_URL; 